import {Avatar} from 'antd'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext} from 'react'
import {BiSolidLike} from "react-icons/bi";
import {renderIf, renderIfElse} from "../../../views/Shared";
import getTitle from "../../../helpers/getTitle";
import getLinkToDetail from "../../../helpers/getLinkToDetail";
import {Link} from "react-router-dom";
import {LayoutContext} from "../../layouts/Default/LayoutContext";
import {BsPersonFill} from "react-icons/bs";
import {BestCommentSvg} from "../../Svgs/BestCommentSvg";
import {formatRelativeTime} from "../../../helpers/dateUtils";

export const BestComment = ({item}) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)

    if (_.isEmpty(item)) return null
    const creator = _.get(item, 'creator', {})
    const mentions = _.get(item, 'mentions', [])

    return (
        <div className="flex flex-col gap-2 relative">
            <div
                style={{top: -10, left: 20, padding: '0.25rem 0.5rem'}}
                className="w-fit bg-yellow-50 border border-orange-200 rounded-full flex items-center gap-2 absolute z-3">
                <BestCommentSvg size={20}/>
                <span className="font-bold text-orange-500 uppercase tracking-wider">
                    {t('best answer')}
                </span>
            </div>
            <div
                style={{boxShadow: '0 4px 6px -1px rgba(254, 243, 199, 0.3), 0 2px 4px -1px rgba(254, 243, 199, 0.15)'}}
                className="my-2 px-3 py-5 flex gap-3 border border-orange-200 rounded-2xl relative">
                <Avatar
                    size={36}
                    src={creator.avatar}
                    icon={<BsPersonFill size={20} className="text-secondary-600"/>}
                    className="mt-0.5 flex flex-center bg-secondary-50"
                />
                <div className="p-3 flex flex-col flex-1 min-w-0 bg-slate-50 rounded-xl relative">
                    <div className="flex items-center justify-between gap-3">
                        <Link
                            to={getLinkToDetail(creator)}
                            className="font-bold text-sm text-gray-800 tracking-wide truncate no-underline">
                            {renderIf(
                                creator?.patron_saint_name,
                                <span className="font-medium text-slate-400 italic">
                                    {creator?.patron_saint_name}{` `}
                                </span>
                            )}
                            {creator.name}
                        </Link>
                        <span className="text-xs text-color-300 tracking-wider">
                            {formatRelativeTime(item?.created)}
                        </span>
                    </div>
                    <div className="my-2 overflow-x-hidden whitespace-pre-line">
                        {renderIfElse(
                            mentions?.length > 0,
                            mentions.map((e, i) => {
                                const owner = _.get(e, 'owner')
                                return (
                                    <span key={i} className="text-color-100">
                                        {owner.content} {' - '}
                                        <Link to={getLinkToDetail(owner.codi_document)}
                                              className="font-medium text-primary">
                                            {getTitle(owner.codi_document)}
                                        </Link>
                                    </span>
                                )
                            }),
                            <span className="text-sm text-slate-700 tracking-wide">
                                {item?.message}
                            </span>
                        )}
                    </div>
                    <div
                        style={{bottom: -12, right: 20, padding: '0.25rem 0.5rem'}}
                        className="w-fit background border border-color-100 text-xs rounded-full flex items-center gap-1 leading-tight absolute">
                        <Avatar
                            size={18}
                            icon={<BiSolidLike size={10} className="text-white"/>}
                            className="flex flex-center bg-blue-600"
                        />
                        <span className="font-semibold text-gray-800">
                            {(item.total_votes).toLocaleString()}
                        </span>
                        <span className="text-slate-400 lowercase">
                            {t('votes')}
                        </span>
                    </div>
                </div>

            </div>
        </div>
    )
}

export const AskContentLayout = ({style, children}) => {
    return (
        <div
            style={style}
            className="space-y-3">
            {children}
        </div>
    )
}

export default AskContentLayout
